import { createSlice } from "@reduxjs/toolkit"
import { EnumReduces } from "@/lib/redux/type"
import { productInitialState } from "./initialState"
import { generateThunkHandler } from "@/utils/redux/generateThunkHandler"
import { productEndpoints, ProductEnumEndpointsName } from "./endpoint"
import { callbackGetCategoryProducts } from "./callbacks/callbackGetCategoryProducts"
import { callbackGetDesignDetail } from "./callbacks/callbackGetDesignDetail"
import * as _ from 'lodash'
import { CartItem } from "./type"

const productSlice = createSlice({
  name: EnumReduces.PRODUCT,
  initialState: productInitialState,
  reducers: {
    selectVariantBundleProduct: (state, { payload: { productId, variantId } }) => {
      for (let i = 0; i < state.design_detail.data.bundle_data.length; i++) {
        const bundleData = state.design_detail.data.bundle_data[i];
        if (bundleData.id === productId) {
          for (let x = 0; x < bundleData.variants.length; x++) {
            const variant = bundleData.variants[x];
            variant.selected = variant.id === variantId
          }
        }
      }
    },
    setCategoryProductsData: (state, { payload: { meta, ...payload } }) => {
      callbackGetCategoryProducts && callbackGetCategoryProducts(
        state,
        { payload, meta },
        ProductEnumEndpointsName.GET_PRODUCT_LIST
      )
    },
    setProductDetailData: (state, { payload }) => {
      callbackGetDesignDetail && callbackGetDesignDetail(
        state,
        { payload },
        ProductEnumEndpointsName.GET_DESIGN
      )
    },
    selectAspectLabel: (state, { payload }) => {
      state.productDetailState.selectedAspectLabel = payload
    },
    selectVariant: (state, { payload: { type, value } }) => {
      const selctedVariant = state.design_detail.data.variants[state.productDetailState.selectedVariantId]
      const attributes = state.design_detail.data.layout.attributes

      const typeData = state.design_detail.data.attributesData[type][value]
      const nextTypeVariants = state.design_detail.data.attributesVariantsMapping[type][typeData?.id || ""] || []

      let variantsByPerTypes = [nextTypeVariants]
      for (let i = 0; i < attributes.length; i++) {
        const attribute = attributes[i];
        if (attribute === type) {
          continue;
        }

        const currentType = selctedVariant.attributes.find(attr => attr.type === attribute)
        const currentTypeVariants = state.design_detail.data.attributesVariantsMapping[attribute][currentType?.id || ""] || []
        variantsByPerTypes.push(currentTypeVariants)
      }
      const variants = _.intersection(...variantsByPerTypes)
      if (variants.length > 0) {
        state.productDetailState.selectedVariantId = variants[0]
      } else {
        state.productDetailState.selectedVariantId = nextTypeVariants[0]
      }
    },
    selectVariantNoDesign: (state, { payload: { type, value } }) => {
      const variantIds = type === 'color' 
      ? (state.product_no_design.data.colorsVariantsMapping || {})[value] || []
      : (state.product_no_design.data.sizesVariantsMapping || {})[value] || []

      const selectedVaraiant = state.product_no_design.data.variants?.find(variant => `${variant.id}` === `${state.productDetailState.selectedVariantId}`)

      if (!selectedVaraiant) {
        state.productDetailState.selectedVariantId = variantIds[0]
        return;
      }
      const otherAttr = (selectedVaraiant.attributes || []).find(attr => attr[type === 'color' ? 'size' : 'color'])
      const otherValue = type === 'color' ? otherAttr?.size : otherAttr?.values?.texture === 'null'|| !otherAttr?.values?.texture ? otherAttr?.values?.color : otherAttr?.values?.texture
      const otherVariantIds = type === 'color' 
        ? (state.product_no_design.data.sizesVariantsMapping || {})[otherValue || ""] || []
        : (state.product_no_design.data.colorsVariantsMapping || {})[otherValue || ""] || []
      const variants = _.intersection(otherVariantIds, variantIds)
      if (variants.length > 0) {
        state.productDetailState.selectedVariantId = variants[0]
      } else {
        state.productDetailState.selectedVariantId = variantIds[0]
      }
    },
    addProductToCart: (state, { payload }) => {
      state.cartItems = state.cartItems.reduce((arr: CartItem[], item) => {
        let alreadyAdded: boolean = false
        for (let i = 0; i < arr.length; i++) {
          const item1 = arr[i];
          if (
            `${item.productId}` === `${item1.productId}`
          ) {
            if (!state.design_detail.data.bundle) {
              if (`${item.variant.id}` === `${item1.variant.id}`) {
                alreadyAdded = true
                arr[i] = {
                  ...arr[i],
                  quantity: item1.quantity + item.quantity
                }
              }
            } else {
              const itemSelected: any = item.products.reduce((obj, product) => {
                const selectedVar = product.variants.find((v: any) => !!v.selected)
                obj[product.id] = selectedVar?.id
                return obj
              }, {})
              const payloadSelected: any = payload.products.reduce((obj: any, product: any) => {
                const selectedVar = product.variants.find((v: any) => !!v.selected)
                obj[product.id] = selectedVar?.id
                return obj
              }, {})

              const productIds = Object.values(payloadSelected)

              if (productIds.every((prodId: any) => (payloadSelected[prodId] === itemSelected[prodId]))) {
                alreadyAdded = true
                arr[i] = {
                  ...arr[i],
                  quantity: item1.quantity + item.quantity
                }
              }
            }


          }
        }
        if (!alreadyAdded) {
          arr.push(item)
        }
        return arr
      }, [payload])
      localStorage.setItem(`items`, JSON.stringify(state.cartItems))
    },
    removeProductFromCard: (state, { payload: { productId, variantId, products } }) => {
      state.cartItems = state.cartItems.filter(item => {
        if (
          `${item.productId}` === `${productId}`
        ) {
          if (!products?.length) {
            if (`${item.variant.id}` === `${variantId}`) {
              return false
            }
          } else {
            const itemSelected: any = item.products.reduce((obj, product) => {
              const selectedVar = product.variants.find((v: any) => !!v.selected)
              obj[product.id] = selectedVar?.id
              return obj
            }, {})
            const payloadSelected: any = products.reduce((obj: any, product: any) => {
              const selectedVar = product.variants.find((v: any) => !!v.selected)
              obj[product.id] = selectedVar?.id
              return obj
            }, {})

            const productIds = Object.values(payloadSelected)

            if (productIds.every((prodId: any) => (payloadSelected[prodId] === itemSelected[prodId]))) {
              return false
            }
          }
          return true
        }
        return true
      })
      localStorage.setItem(`items`, JSON.stringify(state.cartItems))
    },
    forceUpdateAllProducts: (state, { payload }) => {
      state.cartItems = payload
    },
    removeAllProducts: (state) => {
      state.cartItems = []
      localStorage.setItem('items', '[]')
    },
    updateQuantityItem: (state, { payload: { productId, variantId, value, products } }) => {
      for (let i = 0; i < state.cartItems.length; i++) {
        const item = state.cartItems[i];
        if (
          `${item.productId}` === `${productId}`
        ) {
          if (!products?.length) {
            if (`${item.variant.id}` === `${variantId}`) {
              item.quantity = value
            }
          } else {
            const itemSelected: any = item.products.reduce((obj, product) => {
              const selectedVar = product.variants.find((v: any) => !!v.selected)
              obj[product.id] = selectedVar?.id
              return obj
            }, {})
            const payloadSelected: any = products.reduce((obj: any, product: any) => {
              const selectedVar = product.variants.find((v: any) => !!v.selected)
              obj[product.id] = selectedVar?.id
              return obj
            }, {})

            const productIds = Object.values(payloadSelected)

            if (productIds.every((prodId: any) => (payloadSelected[prodId] === itemSelected[prodId]))) {
              item.quantity = value
            }
          }


        }
      }
      localStorage.setItem(`items`, JSON.stringify(state.cartItems))
    },
    updateQuantity: (state, { payload }) => {
      state.quantity = payload
    },
    setCountriesData: (state, { payload }) => {
      state.countries = payload
    },
    setStatesUsData: (state, { payload }) => {
      state.statesUs = payload
    },
    resetCheckCoupon: (state) => {
      state.check_coupon = productInitialState.check_coupon
    }
  },
  extraReducers(builder) {
    generateThunkHandler(builder, EnumReduces.PRODUCT, Object.keys(productEndpoints) as any)
  },
})

export const productActions = productSlice.actions

export default productSlice.reducer